import { Button } from '@/app/components/button';
import { Icon } from '@/app/components/icons';
import { IconLocationOn } from '@/app/components/icons/maps/icon-location-on';
import { IconOpenInNew } from '@/app/components/icons/ui-actions/icon-open-in-new';
import { DEALER_DEFAULT_VALUE } from '@/app/components/shared/dealer/utils/dealer-constant';
import { EVENT_NAME } from '@/app/components/shared/dealer/utils/tracking';
import type { DealerSearch } from '@/app/components/shared/dealer/utils/types';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';

interface AddressBoxProps {
  selectedType?: DealerSearch['sale' | 'aftersale' | 'bp'] | null;
  googleMapUrl: string;
}

export const AddressBox = ({ selectedType, googleMapUrl }: AddressBoxProps) => {
  return (
    <div
      className="bg-silver-50 flex items-center justify-between gap-x-4 rounded-xs px-4 py-3 xl:my-0"
      {...createDataAttributes({ test: 'address-box' })}
    >
      <div className="flex items-center gap-x-3">
        <Icon className="size-5" icon={<IconLocationOn />} />
        <span
          className="text-body-2-fixed"
          {...createDataAttributes({ test: 'address' })}
        >
          {selectedType?.address || DEALER_DEFAULT_VALUE.ADDRESS}
        </span>
      </div>
      <Button
        className="shrink-0"
        target="_blank"
        size="xs"
        color="white"
        iconBefore={<IconOpenInNew />}
        aria-label="Open google map"
        href={googleMapUrl}
        {...createDataAttributes({ test: 'google-map' })}
        {...createDataGA({
          click: true,
          eventName: EVENT_NAME,
          group: 'components/shared/dealer/shared/search-panel/dealer-detail',
          url: googleMapUrl,
          text: 'Google Map',
        })}
      />
    </div>
  );
};
